import { AfterViewInit, Component, ViewChild } from "@angular/core";
import {
  Platform,
  Events,
  AlertController,
  App,
  NavController,
} from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "@providers/auth.service";
import { ApiService } from "@providers/api.services";
@Component({
  templateUrl: "app.html",
})
export class MyApp implements AfterViewInit {
  @ViewChild("rootNav") __rootNav: NavController;
  private __rootPage: any;
  private __pagesReady: boolean = false;
  private __rootReady: boolean = false;
  private __noStorage: boolean = false;
  private __rootPrams: { path: string };

  constructor(
    private _authCtrl: AuthService,
    private _apiCtrl: ApiService,
    private _platformCtrl: Platform,
    private _translateCtrl: TranslateService,
    private _eventCtrl: Events,
    private _alertCtrl: AlertController,
    private _appCtrl: App,
  ) {
    this.initializeApp();
    this._eventCtrl.subscribe(
      "pages:isready",
      (_callback: (_ready: boolean) => void) => {
        let inter = setInterval(() => {
          if (this.__pagesReady) {
            clearInterval(inter);
            _callback(true);
          }
        }, 100)
      }
    );
  }
  initializeApp() {
    console.log('init')
    this._translateCtrl.use("fr");
    this._eventCtrl.subscribe(
      "pages:change:root",
      (_data: { page: string; paylod: any }) => {
        if (this.__pagesReady) {
          // this._appCtrl.viewDidLoad.
          if (this.__rootNav) {
            this.__rootNav.setRoot(_data.page, _data.paylod);
          }
        }
      }
    );

    this._platformCtrl.ready().then(
      () => {
        this._authCtrl.storage("auth").then(
          (result) => {
            if (result) {
              if (result.token) {
                this._authCtrl
                  .authenticate(result.user, result.token, true)
                  .then(() => {



                    this._apiCtrl
                      .authenticate(result.token)
                      .then(() => {
                        this._apiCtrl.is_ready = true;
                      })
                      .then(() => {
                        this.__pagesReady = true;
                        if (window.location.hash === "") {
                          // this._appCtrl.getRootNavById("Dashboard").setRoot();
                          this._appCtrl.getRootNav().setRoot("Dashboard", {
                            path: window.location.hash,
                          });
                        }

                        this._eventCtrl.publish(
                          "pages:ready",
                          this.__pagesReady
                        );
                      });
                  });
              } else {
                if (
                  window.location.hash.indexOf("reset") > -1 ||
                  window.location.hash.indexOf("confirm") > -1
                ) {
                } else {
                  this._appCtrl.getRootNav().setRoot("Signin", {
                    path: window.location.hash,
                  });
                }
                this._apiCtrl.is_ready = true;
              }
              this.__pagesReady = true;

              this._eventCtrl.publish("pages:ready", this.__pagesReady);
            } else {
              if (
                window.location.hash.indexOf("reset") > -1 ||
                window.location.hash.indexOf("confirm") > -1
              ) {
              } else {
                setTimeout(() => {
                  this._appCtrl.getRootNav().setRoot("Signin", {
                    path: window.location.hash,
                  });
                }, 100);

                this.__pagesReady = true;
                this._eventCtrl.publish("pages:ready", this.__pagesReady);
              }
            }
          },
          () => {
            this.__noStorage = !this.__noStorage;
          }
        );
      },
      () => console.log("error device")
    );

    this._eventCtrl.subscribe("alert", (alert) => {
      this._alertCtrl.create(alert).present();
    });
    this._eventCtrl.subscribe(
      "page:navigate",
      (_data: { path: string; redirect: boolean }) => {
        const redirect: string = `?redirect=${window.location.hash.replace(
          /#/g,
          ""
        )}`;
        window.location.hash = _data.redirect
          ? `/${_data.path}${redirect}`
          : `/${_data.path}`;
      }
    );
  }
  ngAfterViewInit() {
    // this.__rootReady = true;
  }

  public get rootReady(): boolean {
    return this.__rootReady
  }

  public get rootPage(): any {
    return this.__rootPage;
  }
  public get rootPrams(): any {
    return this.__rootPrams;
  }
  public get noStorage(): any {
    return this.__noStorage;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts